import React from 'react';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';

class EditFavorite extends React.Component {
  constructor(props) {
    super(props);
    this.AddFavoriteClick = this.AddFavoriteClick.bind(this);
    this.ResetFavoriteClick = this.ResetFavoriteClick.bind(this);
    this.state = {
      IsFavorite: this.props.IsFavorite
    }
  }
  AddFavoriteClick(e) {
    e.preventDefault();

    fetch(this.props.add_url, {
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': this.props.token
      }
    }).then((res) => {
      return res.json();
    }).then((data) => {
      if (data.status == 200) {
        this.setState((prevState) => ({ IsFavorite: !prevState.IsFavorite }))
        document.getElementById("favorite_count").textContent = data.favorite_count;
      }
    }).catch((err) => {
      console.error(err);
    });
  }
  ResetFavoriteClick(e) {
    e.preventDefault();

    fetch(this.props.reset_url, {
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': this.props.token
      }
    }).then((res) => {
      return res.json();
    }).then((data) => {
      if (data.status == 200) {
        this.setState((prevState) => ({ IsFavorite: !prevState.IsFavorite }))
        document.getElementById("favorite_count").textContent = data.favorite_count;
      }
    }).catch((err) => {
      console.error(err);
    });
  }
  render() {
    return (
      <Selector
        AddFavoriteClick={this.AddFavoriteClick}
        ResetFavoriteClick={this.ResetFavoriteClick}
        IsFavorite={this.state.IsFavorite}
      />
    )
  }
}

const Selector = (props) => {
  if (props.IsFavorite) {
    return <a className="btn_star" href='true' onClick={ props.ResetFavoriteClick }>お気に入りを取消</a>
  } else {
    return <a className="btn_star" href='true' onClick={ props.AddFavoriteClick }>お気に入りを追加</a>
  }
}

export default EditFavorite